import { FormState } from '@vtex/admin-ui-form'
import { FormattedMessage } from 'react-intl'
import { RegularScopeApplyTo } from '../../../../../../typings'
import { SCOPE_OPTIONS } from '../../../../../ItemsView/typing'
import {
  BrandsScopeSelector,
  CategoriesScopeSelector,
  CollectionsScopeSelector,
  ProductsScopeSelector,
  SkusScopeSelector,
} from './Selectors'
import { messages } from './messages'

export const applyToItemsValues: {
  value: RegularScopeApplyTo
  label: JSX.Element
}[] = [
  {
    value: RegularScopeApplyTo.allItems,
    label: <FormattedMessage {...messages.applyTo.allItems} />,
  },
  {
    value: RegularScopeApplyTo.filteredItems,
    label: <FormattedMessage {...messages.applyTo.filteredItems} />,
  },
]

export type SelectorComponentProps = {
  name: SCOPE_OPTIONS
  form: FormState
  open: boolean
}

export const SELECTOR_MAP: Record<
  SCOPE_OPTIONS,
  (props: SelectorComponentProps) => JSX.Element | null
> = {
  [SCOPE_OPTIONS.SKUS]: SkusScopeSelector,
  [SCOPE_OPTIONS.PRODUCTS]: ProductsScopeSelector,
  [SCOPE_OPTIONS.COLLECTIONS]: CollectionsScopeSelector,
  [SCOPE_OPTIONS.CATEGORIES]: CategoriesScopeSelector,
  [SCOPE_OPTIONS.BRANDS]: BrandsScopeSelector,
}
